import { Stack } from '@mui/material';
import { HeaderBreadcrumbs, ScreenWrap, SoloLoading } from '../../components';
import ReflectionPointForm from './ReflectionPointForm';
import { useParams } from 'react-router';
import { Api } from '../../api';

export default function EditReflectionPointScreen() {
  const { weekNumber, weekId, id } = useParams();

  const api = Api.ReflectionPoint.useReadItemAsAdmin(id ?? '');

  if (!api.data) return <SoloLoading />;

  return (
    <ScreenWrap>
      <Stack gap={3}>
        <HeaderBreadcrumbs
          title="Edit Reflection Point"
          items={[
            {
              name: `Program Week ${weekNumber}`,
              url: `/program/${weekNumber}/${weekId}/reflection-points`,
            },
          ]}
        />
        <ReflectionPointForm existing={api.data} />
      </Stack>
    </ScreenWrap>
  );
}
